<template>
  <div :class="generatorMainSectionClass">
    <div :class="generatorTableSectionClass">
      <div class="row top-space">
        <ul class="nav nav-tabs">
          <li class="nav-item common-tab">
            <a :class="centralProductsTabClass" aria-current="page" @click="openProductsListStage('CENTRAL')">Centralne
              kartoteki towarów</a>
          </li>
          <li class="nav-item common-tab">
            <a :class="localDrugstoresProductsTabClass" @click="openProductsListStage('LOCAL')">Dane towarów z
              aptek</a>
          </li>

        </ul>
        <div class="top-space">
          <div v-if="currentProductsContext === 'CENTRAL'" class="mb-3 windows-like-breadcrumb-card shadow-sm">
            <ProductDataList :enableRowSelection="false"/>
          </div>
          <div v-else-if="currentProductsContext === 'LOCAL'" class="mb-3 windows-like-breadcrumb-card shadow-sm">
            <DrugstoresProductsLocalDataList :enableRowSelection="false"/>
          </div>

        </div>


      </div>
    </div>
  </div>

</template>


<script>
import ProductDataList from "./ProductDataList.vue";
import {log} from "@/state/pinia/log";
import DrugstoresProductsLocalDataList from "./DrugstoresProductsLocalDataList.vue";
import {mapStores} from "pinia";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";



import {useLayoutStore} from "@/state/pinia";



export default {
  name: "ProductsStage",
  props: {

    displayInBootstrapRow: {
      type: Boolean,
      default: () => false
    },
  },
  components: {
    DrugstoresProductsLocalDataList,
    ProductDataList

  },
  data() {
    return {
      centralProductsTabClass: "nav-link active",
      localDrugstoresProductsTabClass: "nav-link",
      currentProductsContext: "CENTRAL",

    };
  },
  computed: {
    simplepharmAuth() {
      return useSimplepharmAuthModule();
    },
    commonModule() {
      return useCommonAppModule();
    },
    lazyloaderModule() {
      return useLazyLoaderModule();
    },
    layoutStore() {
      return useLayoutStore();
    },
    layout: {
      get() {
        return this.layoutStore.layoutType;
      },
      set(layout) {
        this.layoutStore.changeLayoutType(layout);
      }
    },
    generatorTableSectionClass() {
      if (this.layout === 'vertical' || this.displayInBootstrapRow) {
        return 'generator-table-container-vertical windows-like-breadcrumb-card shadow-sm scrollable-container';
      } else {
        return 'generator-table-container windows-like-breadcrumb-card shadow-sm scrollable-container';
      }
    },
    generatorMainSectionClass() {
      if (this.layout === 'vertical' || this.displayInBootstrapRow) {
        return 'row package-orders-generator-site';
      } else {
        return 'package-orders-generator-site';
      }
    },

  },
  methods: {

    openProductsListStage(openedPaymentType) {
      this.currentProductsContext = openedPaymentType;
      if (openedPaymentType === "CENTRAL") {
        this.centralProductsTabClass = "nav-link active";
        this.localDrugstoresProductsTabClass = "nav-link";
      } else if (openedPaymentType === "LOCAL") {
        this.centralProductsTabClass = "nav-link";
        this.localDrugstoresProductsTabClass = "nav-link active";

      }

    }

  },
  watch: {},
  mounted() {
    this.commonModule.setHorizontalNavbarTitle(`<i class="bx bx-home-circle me-1"></i> Towary`)
  },
  created() {
    log.log("trigger refresh token")
    this.simplepharmAuth.refreshToken().then(() => {
      this.commonModule.httpGetLicensedFeatures();
      this.commonModule.httpGetWorkingProfile();

    });
  },
};
</script>

<style scoped>
.top-space {
  padding-top: 8px;
}

.common-tab {
  cursor: pointer;
}



.package-orders-generator-site {

}
</style>
